"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ParagraphViewMode = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Spinner = _interopRequireDefault(require("../common/Spinner"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var ParagraphViewContainer = _styledComponents.styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 12px 16px;\n  flex-direction: column;\n  justify-content: stretch;\n  align-items: flex-start;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid var(--Gray-stroke, #CCC);\n  background: #FFF;\n  min-height: 140px;\n  max-height: 400px;\n  margin-bottom: 20px;\n"])));
var HeaderContainer = _styledComponents.styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  align-items: flex-start;\n  align-self: stretch;\n  display: flex;\n  flex: 0 0 auto;\n  justify-content: space-between;\n  position: relative;\n  width: 100%;\n\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.28px;\n  line-height: 21px;\n  white-space: nowrap;\n"])));
var PaginationContainer = _styledComponents.styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  align-items: center;\n  display: inline-flex;\n  flex: 0 0 auto;\n  gap: 4px;\n  position: relative;\n\n  font-size: 12px;\n  font-weight: 400;\n  letter-spacing: 0.24px;\n  line-height: normal;\n"])));
var PaginationButton = _styledComponents.styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 20px;\n  position: relative;\n  width: 20px;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n  background-color: #FFFFFF;\n\n  &:hover {\n    background-color: #dddbdb;\n  }\n"])));
var ContentArea = _styledComponents.styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  overflow-y: auto;\n  box-sizing: border-box;\n  width: 100%;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  letter-spacing: 0.56px;\n  overflow-wrap: break-word;\n"])));
var ParagraphViewMode = exports.ParagraphViewMode = /*#__PURE__*/function (ParagraphViewMode) {
  ParagraphViewMode[ParagraphViewMode["FirstParty"] = 0] = "FirstParty";
  ParagraphViewMode[ParagraphViewMode["ThirdParty"] = 1] = "ThirdParty";
  return ParagraphViewMode;
}({});
var ParagraphView = function ParagraphView(_ref) {
  var mode = _ref.mode,
    paragraphs = _ref.paragraphs,
    onSelectedParagraphChange = _ref.onSelectedParagraphChange,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedParagraph = _useState2[0],
    setSelectedParagraph = _useState2[1];
  var selectPrevParagraph = function selectPrevParagraph() {
    if (paragraphs.length > 0 && selectedParagraph > 0) {
      setSelectedParagraph(selectedParagraph - 1);
      onSelectedParagraphChange(selectedParagraph - 1);
    }
  };
  var selectNextParagraph = function selectNextParagraph() {
    if (paragraphs.length > 0 && selectedParagraph < paragraphs.length - 1) {
      setSelectedParagraph(selectedParagraph + 1);
      onSelectedParagraphChange(selectedParagraph + 1);
    }
  };
  var getParagraphView = function getParagraphView() {
    if (isLoading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentArea, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spinner.default, {})
      });
    }
    if (paragraphs.length > 0) {
      switch (mode) {
        case ParagraphViewMode.FirstParty:
          {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentArea, {});
          }
        case ParagraphViewMode.ThirdParty:
          {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentArea, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: paragraphs[selectedParagraph]
                }
              })
            });
          }
      }
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentArea, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          style: {
            textAlign: "center",
            color: "#666"
          },
          children: "No Sections Found"
        })
      });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(ParagraphViewContainer, {
    "data-sentry-element": "ParagraphViewContainer",
    "data-sentry-component": "ParagraphView",
    "data-sentry-source-file": "ParagraphView.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(HeaderContainer, {
      "data-sentry-element": "HeaderContainer",
      "data-sentry-source-file": "ParagraphView.tsx",
      children: [mode === ParagraphViewMode.FirstParty ? "Original Text" : "", paragraphs.length > 1 && /*#__PURE__*/(0, _jsxRuntime.jsxs)(PaginationContainer, {
        children: ["Paragraph ", selectedParagraph + 1, " of ", paragraphs.length, /*#__PURE__*/(0, _jsxRuntime.jsx)(PaginationButton, {
          onClick: selectPrevParagraph,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M3.14807 18.8333L16.8518 18.8333C17.67 18.8333 18.3333 18.17 18.3333 17.3518L18.3333 3.64807C18.3333 2.82987 17.67 2.16659 16.8518 2.16659L3.14807 2.16659C2.32987 2.16659 1.66659 2.82987 1.66659 3.64807L1.66659 17.3518C1.66659 18.17 2.32987 18.8333 3.14807 18.8333Z",
              stroke: "#555555",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M5.83317 12.1665L9.53 8.98688C9.58565 8.93902 9.6569 8.9003 9.73833 8.87366C9.81975 8.84702 9.9092 8.83317 9.99984 8.83317C10.0905 8.83317 10.1799 8.84702 10.2613 8.87366C10.3428 8.9003 10.414 8.93902 10.4697 8.98688L14.1665 12.1665",
              stroke: "#555555",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PaginationButton, {
          onClick: selectNextParagraph,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "21",
            viewBox: "0 0 20 21",
            fill: "none",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M1.66675 3.64807L1.66675 17.3518C1.66675 18.17 2.33003 18.8333 3.14823 18.8333H16.8519C17.6701 18.8333 18.3334 18.17 18.3334 17.3518V3.64807C18.3334 2.82987 17.6701 2.16659 16.8519 2.16659H3.14823C2.33003 2.16659 1.66675 2.82987 1.66675 3.64807Z",
              stroke: "#555555",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M14.1663 8.83341L10.4695 12.013C10.4139 12.0609 10.3426 12.0996 10.2612 12.1263C10.1798 12.1529 10.0903 12.1667 9.99967 12.1667C9.90903 12.1667 9.81959 12.1529 9.73816 12.1263C9.65674 12.0996 9.58548 12.0609 9.52983 12.013L5.83301 8.83341",
              stroke: "#555555",
              strokeWidth: "1.25",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })]
          })
        })]
      })]
    }), getParagraphView()]
  });
};
var _default = exports.default = ParagraphView;